import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import classNames from 'classnames';
import useCFFilters from './useCFFilters';
var ShowOpenCourses = function (props) {
    var showOpenOnlyCourses = useCFFilters({}).showOpenOnlyCourses;
    return (React.createElement("div", { "data-hasValue": showOpenOnlyCourses, onClick: function () {
            var _a;
            (_a = props === null || props === void 0 ? void 0 : props.handleFilterApply) === null || _a === void 0 ? void 0 : _a.call(props, {
                name: props === null || props === void 0 ? void 0 : props.name,
                value: !showOpenOnlyCourses ? [{ label: 'Show Open Courses Only', value: 'OPEN' }] : null
            });
        }, className: classNames('lfc-w-[190px]  lfc-rounded-[4px] lfc-p-[0.5rem] lfc-text-[#00000099] lfc-border-gbTokens-grey-A600 lfc-flex lfc-h-[37px] lfc-border lfc-cursor-pointer lfc-items-center lfc-justify-center ', {
            'lfc-bg-primary-100 lfc-text-primary-500 lfc-border lfc-border-gbTokens-primary-500': !!showOpenOnlyCourses
        }, { 'lfc-bg-white hover:lfc-border hover:lfc-border-black': !showOpenOnlyCourses && !(props === null || props === void 0 ? void 0 : props.disabled) }, { 'lfc-pointer-events-none !lfc-bg-gbTokens-grey-A500': props === null || props === void 0 ? void 0 : props.disabled }) },
        React.createElement(GBTypography, { variant: showOpenOnlyCourses ? 'sh3Semibold' : 'sh3Regular' }, "Show Open Courses Only")));
};
export default ShowOpenCourses;
//# sourceMappingURL=ShowOpenCourses.js.map